/** iPhone / iPod / iPad (iPadOS 13+ reports as desktop Safari, so a touch-capable Mac counts too). */
export function isIOS() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    const iOSDevice = /iP(ad|hone|od)/.test(ua);
    const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return iOSDevice || iPadOS;
}

export default isIOS;
